import Gallery from '../Gallery/Gallery';

function getAspectRatio(width, height) {
	const w = parseFloat(width);
	const h = parseFloat(height);
	if (isNaN(w) || isNaN(h) || h === 0) {
		throw new Error("Invalid width or height");
	}
	return w / h;
}

const SimpleImage = ({ src, alt, width, height, style }) => {
	return (
		<div style={{ aspectRatio: getAspectRatio(width, height), ...style }}>
			<Gallery
				style={{
					width: "100%",
					height: "100%",
				}}
				imageInfos={[{
					width: 1,
					height: 1,
					image: <img src={src} alt={alt} />
				}]}
			/>
		</div>
	);
};

// A SimpleImage takes on the dimensions of the actual image it's embedding
export default SimpleImage;
